import React from 'react';
import styled from 'styled-components';
import Icon from '@components/dataDisplay/Icons/Icon';
import Tooltip from '../Tooltip';

const PreviewWrapper = styled.div <{
  minHeight?: number | string;
  aspectRatio?: string;
}>`
  width: 100%;
  height: 100%;
  min-height: ${({ minHeight }) =>
    typeof minHeight === 'number' ? `${minHeight}px` : minHeight || '200px'};
  position: relative;
  overflow: hidden;
  border: 1px solid var(--lineColor);
  border-radius: var(--cardBorderRadius);
  display: flex;
  flex-direction: column;

  ${({ aspectRatio }) => aspectRatio && `aspect-ratio: ${aspectRatio};`}
`;

const PreviewImg = styled.div<{
  imgURL?: string | null;
  cover?: boolean;
}>`
  width: 100%;
  height: 100%;
  flex: 1;
  background: ${({ cover }) => (cover ? 'center/cover' : 'center/contain')}
    no-repeat ${({ imgURL }) => (imgURL ? `url('${imgURL}')` : '')};
  background-color: var(--cardBackgroundColor);
`;

const DeleteBtn = styled.button`
  background-color: var(--buttonBackgroundColor);
  width: 30px;
  height: 30px;
  border-radius: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: var(--inkColor);
  }
`;

const DeleteBtnSec = styled.div`
  position: absolute;
  right: 8px;
  top: 8px;
`;

type PreviewSecProps = {
  imgURL?: string | null;
  reset?: () => void;
  style?: any;
  cover?: boolean;
  minHeight?: number | string;
  aspectRatio?: string;
};

function PreviewSec({
  imgURL,
  reset,
  style,
  cover,
  minHeight,
  aspectRatio,
}: PreviewSecProps) {
  return imgURL ? (
    <PreviewWrapper
      style={style}
      minHeight={minHeight}
      aspectRatio={aspectRatio}
    >
      <PreviewImg imgURL={imgURL} cover={cover} />
      {reset && (
        <DeleteBtnSec>
          <Tooltip message="이미지 삭제" direction="left">
            <DeleteBtn onClick={reset}>
              <Icon name="X12" color="var(--buttonTextColor)" />
            </DeleteBtn>
          </Tooltip>
        </DeleteBtnSec>
      )}
    </PreviewWrapper>
  ) : null;
}

export default React.memo(PreviewSec);
